<!-- @format -->
<ng-container *transloco="let t">
  <div
    class="sis-plan-structure-composite-rule"
    role="group"
    [attr.id]="this.ruleFocusId()"
    [tabIndex]="-1"
    [attr.aria-labelledby]="selectionUIState !== 'DISABLED' ? ruleLegendId() : undefined">
    @if (selectionUIState !== "DISABLED" && showCountRuleHeader) {
      <sis-plan-structure-count-rule-header
        [rule]="_rule()"
        [onlyShowRule]="selectionUIState === 'SELECTABLE'"
        [ruleLegendId]="ruleLegendId()"
        [ruleValidationResults]="ruleValidationResults()">
      </sis-plan-structure-count-rule-header>
    }
    @if (selectionUIState === "ACTIVE" || selectionUIState === "SELECTABLE") {
      @if (_rule().description; as description) {
        <fudis-dl>
          <fudis-dl-item>
            <fudis-dt [contentText]="t('FIELD_NAMES.guidance')"></fudis-dt>
            <fudis-dd>
              <sis-localized-markup-string-view [content]="description"></sis-localized-markup-string-view>
            </fudis-dd>
          </fudis-dl-item>
        </fudis-dl>
      }
    }
    @if (ruleErrors && ruleErrors()?.length > 0) {
      <sis-plan-structure-rule-error-list [ruleErrors]="ruleErrors()"> </sis-plan-structure-rule-error-list>
    }
    <div class="sis-plan-structure-composite-rule__body">
      @for (rule of courseUnitAndModuleRules(); track trackByFunc($index, rule)) {
        <div class="sis-mb-sm sis-pr-sm">
          <sis-plan-structure-select-rule
            [rule]="rule"
            [headingLevel]="headingLevel"
            [ruleDepthLevel]="ruleDepthLevel + 1"
            [parentModule]="_parentModule()"
            [planStateObject]="_planStateObject()"
            [selectionUIState]="selectionUIState === 'ACTIVE' ? 'ACTIVE' : 'DISABLED'"
            [groupPrefix]="''">
          </sis-plan-structure-select-rule>
        </div>
      }
      @for (rule of groupRules(); track trackByFunc(i, rule); let i = $index) {
        <div class="list-group-item sis-mb-sm">
          <div
            [class]="{
              'rule-group': true,
              'rule-group--active': groupRuleUISelectionStates()[rule.localId],
            }">
            <div class="sis-pl-sm sis-mb-sm sis-pr-sm">
              @if (showSelectionGroupRule(rule)) {
                @if (isSelectAllRule()) {
                  <span class="sis-label">{{
                    t("PLAN_EDIT.SELECTION_MODAL.RULE_BODY.SELECTION_GROUP") +
                      " " +
                      (groupPrefix ? groupPrefix + "." + visibleSelectionGroupNumber(rule) : visibleSelectionGroupNumber(rule))
                  }}</span>
                } @else {
                  @if (selectionUIState === "ACTIVE" || groupRuleUISelectionStates()[rule.localId]) {
                    @if (isSelectOneRule()) {
                      <div class="plan-structure-composite-single-rule-radio-button">
                        <sis-simple-radio-button
                          [id]="rule.localId"
                          [name]="_rule().localId"
                          [selected]="groupRuleUISelectionStates()[rule.localId]"
                          [label]="
                            t('PLAN_EDIT.SELECTION_MODAL.RULE_BODY.SELECTION_GROUP') +
                            ' ' +
                            (groupPrefix ? groupPrefix + '.' + visibleSelectionGroupNumber(rule) : visibleSelectionGroupNumber(rule))
                          "
                          (selectedChange)="toggle(!groupRuleUISelectionStates()[rule.localId], rule)" />
                      </div>
                    } @else {
                      <sis-checkbox
                        [checked]="groupRuleUISelectionStates()[rule.localId]"
                        [id]="rule.localId"
                        (checkedChange)="toggle(!groupRuleUISelectionStates()[rule.localId], rule)"
                        [name]="_rule().localId"
                        [label]="
                          t('PLAN_EDIT.SELECTION_MODAL.RULE_BODY.SELECTION_GROUP') +
                          ' ' +
                          (groupPrefix ? groupPrefix + '.' + visibleSelectionGroupNumber(rule) : visibleSelectionGroupNumber(rule))
                        ">
                      </sis-checkbox>
                    }
                  }
                }
                @if (selectionUIState === "DISABLED") {
                  <span class="sis-label">
                    {{ t("PLAN_EDIT.SELECTION_MODAL.RULE_BODY.SELECTION_GROUP") }}
                    {{ groupPrefix ? groupPrefix + "." + visibleSelectionGroupNumber(rule) : visibleSelectionGroupNumber(rule) }}
                  </span>
                }
              }
              <sis-plan-structure-select-rule
                [rule]="rule"
                [headingLevel]="headingLevel"
                [ruleDepthLevel]="ruleDepthLevel + 1"
                [groupPrefix]="nextGroupPrefix(rule)"
                [parentModule]="_parentModule()"
                [planStateObject]="_planStateObject()"
                [selectionUIState]="this.resolveGroupUiState(rule)">
              </sis-plan-structure-select-rule>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-container>
